module.exports = __webpack_public_path__ + "media/bootstrap-icons/mastodon-571503ac.svg";